<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->
<div class="geo-filters" [formGroup]="geoForm">
    <ul>
        <li>
            <h2> Geographic View </h2>
            <p-dropdown [tabindex]='tabIndex + 1' [options]="geoList" (onChange)="checkGeoView($event)" formControlName="selectedGeoView"></p-dropdown>
        </li>
        <li>
            <h2> {{'system'!=geoForm.controls['selectedGeoView'].value?geoDescriptionLabel:''}} &nbsp;</h2>
            <p-dropdown [tabindex]='tabIndex + 2' [options]="geoDescriptionList" [disabled]="'system'==geoForm.controls['selectedGeoView'].value"
                formControlName="selectedGeoDescriptions"></p-dropdown>
        </li>
    </ul>
</div>